import { TertiaryButton, palette } from '@dev/ee-components';
import { Link } from '@material-ui/core';
import styled from 'styled-components';

export const OnboardingStepLinksWrapper = styled.div`
    border: 1px solid ${palette.gray[3]};
    background: ${palette.basic.paper};
    border-radius: 4px;

    display: flex;
    flex-direction: column;
`;

export const OnboardingStepLinksItem = styled.div`
    border-bottom: 1px solid ${palette.gray[3]};
    display: flex;
    width: 100%;

    &:last-child {
        border-width: 0;
    }
`;

export const OnboardingStepLinksLink = styled(Link)`
    width: 100%;
`;

export const OnboardingStepLinksButton = styled(TertiaryButton)`
    padding: 20px 40px !important;
    width: 100%;
    justify-content: start !important;
    word-wrap: break-word;
    white-space: normal;
    text-align: left;
`;
